import { englewoodConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function EnglewoodPage() {
  return <CityPageTemplate config={englewoodConfig} />;
}